export default "__VITE_ASSET__Cslo7xei__"